import {auth, firestore} from './firebase';
import firebase from 'firebase/app';

function Migrate(data, uid) {
	if (data.version === 1) { //migrate to 2
		console.log("I'm here")
		var tree = data.tree;
		tree['taskLists'] = {0: {id: 0, name: "", taskOrder: []}, 1: {id: 1, name: "Now", taskOrder: tree.nowTaskOrder}, 2: {id: 2, name: "Later", taskOrder: tree.laterTaskOrder}}
		tree['taskListOrder'] = [1,2];
		tree['maxTaskListId'] = 2;

		var updates = {};
		updates['version'] = 2;
    updates[`tree.taskLists`] = tree['taskLists'];
    updates[`tree.taskListOrder`] = tree['taskListOrder'];
    updates[`tree.maxTaskListId`] = tree['maxTaskListId'];
    updates[`tree.nowTaskOrder`] = firebase.firestore.FieldValue.delete()
    updates[`tree.laterTaskOrder`] = firebase.firestore.FieldValue.delete()
    firestore.doc(`users/${uid}`).update(updates);
		//set new version and set new tree
		return data;;
	}
	return data; 
}




export default Migrate;



// maxTaskListId: 4,
//                   startFocusId: 1,
//                   taskLists: {0: {id: 0, name: "", taskOrder: []}, 1: {id: 1, name: "Important and Urgent", taskOrder: [8]}, 2: {id: 2, name: "Important and Not Urgent", taskOrder: []}, 3: {id: 3, name: "Not Important and Urgent", taskOrder: []}, 4: {id: 4, name: "Not Important and Not Urgent", taskOrder: []} },
//                   taskListOrder: [1,2,3,4],
//                   completedTasks: [],
//                   1: {id: 1, t: null, kids: [2], parentId: null, expand: true},
//                   2: {id: 2, t: 'Movies', kids: [3,4], parentId: 1, expand: true},    
//                   3: {id: 3, t: 'Secret Life of Pets', kids: [5,6], parentId: 2, expand: true},    
//                   4: {id: 4, t: 'Matrix', kids: [7],isRootNode: true, parentId: 2, expand: true},    
//                   5: {id: 5, t: 'Snowball', kids: [], parentId: 3, expand: true},    
//                   6: {id: 6, t: 'Max', kids: [], parentId: 3, expand: true}, 
//                   7: {id: 7, t: 'Neo', kids: [8], parentId: 4, expand: true},
//                   8: {id: 8, t: 'Knock knock neo...', kids: [], parentId: 7, expand: true, due: date, complete: false},